const styles = (theme) => ({
  container: {
    margin: 0,
    minHeight: 200,
    [theme.breakpoints.up('sm')]: {
      margin: '1vw auto',
      minWidth: 900,
    },
    maxWidth: 900,
  },
  alertContainer: {
    margin: 0,
    minHeight: 200,
    [theme.breakpoints.up('sm')]: {
      margin: '1vw auto',
    },
    maxWidth: 900,
    padding: theme.spacing(0, 3),
  },
  alertFooter: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(7),
      marginBottom: theme.spacing(2),
    },
  },
  iconcontainer: {
    textAlign: 'center',
    margin: `${theme.spacing(3)}px auto ${theme.spacing(2)}px`,
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(2.5)}px auto ${theme.spacing(2.5)}px`,
    },
  },
  message: {
    margin: theme.spacing(1.3, 1, 1),
    textAlign: 'center',
    lineHeight: 1.3,
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(1.3, 2, 2),
    },
  },
  errorIcon: {
    color: theme.palette.grey.main,
    paddingRight: theme.spacing(0.6),
    width: '10em',
    height: '4em',
  },
  restartLink: {
    fontWeight: 600,
    fontSize: 16,
  },
  iconContainerIdUpload: {
    textAlign: 'center',
    marginTop: `${theme.spacing(22)}px`,
    [theme.breakpoints.up('sm')]: {
      marginTop: `${theme.spacing(12)}px`,
    },
  },
  messageIdUpload: {
    textAlign: 'center',
    paddingTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(5.5),
    },
  },
  subMessageIdUpload: {
    textAlign: 'center',
    color: '#828D99',
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(1),
    },
  },
  websiteLinkIdUpload: {
    fontWeight: '500',
    textAlign: 'center',
    paddingTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(11),
      paddingBottom: theme.spacing(14),
    },
  },
});

export default styles;
